// contexts/LogContext.js
import { createContext, useMemo, useReducer } from "react";
import {
  logHandlers,
  logInitialState,
  logReducer,
} from "../reducers/LogReducer";

export const _showAppLogs = {
  appInfo: false,
  appProfiles: false,
  baseSettings: false,
  cache: false,
  clientInfo: false,
  dataDocuments: false,
  dbFetch: false,
  eventInfo: false,
  firestore: false,
  itemData: false,
  manifest: false,
  regInfo: false,
  settings: false,
  sportInfo: true,
  storageInfo: false,
  timestamps: true,
  viewSettings: true,
  useSportResults: true,
  useSportsInfo: true,
}

export const LogContext = createContext();

const LogProvider = (props) => {
  const init_state = {};
  const [log_state, log_dispatch] = useReducer(
    logReducer,
    init_state,
    logInitialState
  );

  const log_handlers = useMemo(() => logHandlers(log_dispatch), [log_dispatch]);

  return (
    <LogContext.Provider value={{ log_state, log_handlers }}>
      {props.children}
    </LogContext.Provider>
  );
};

export default LogProvider;
